/**
 * Opening screen — session handling and early dismissal.
 *
 * The panel shows and clears itself in CSS. This file only decides whether it
 * should have run at all, and lets someone skip it. Nothing here is required to
 * reveal the page: if this script never loads, the CSS still fades the panel out
 * on schedule.
 *
 * The important behaviour is the once-per-visit rule. Without it the panel would
 * sit in front of every navigation — five seconds before each product, each
 * collection, each step of checking out — which is the difference between an
 * opening moment and an obstruction.
 */
(() => {
  const panel = document.querySelector('[data-oracura-intro]');
  if (!panel) return;

  const KEY = 'oracura:intro-seen';

  const dismiss = () => {
    if (panel.hidden) return;
    panel.hidden = true;
  };

  // Private browsing and blocked storage both throw on access rather than
  // returning null, so every read and write is guarded. A visitor whose browser
  // refuses storage simply sees the panel each time rather than hitting an error.
  let seen = false;
  try {
    seen = sessionStorage.getItem(KEY) === '1';
  } catch (error) {
    seen = false;
  }

  if (seen) {
    // Already shown this visit — clear it before the first frame so it never
    // flashes on the way to a second page.
    dismiss();
    return;
  }

  try {
    sessionStorage.setItem(KEY, '1');
  } catch (error) {
    /* storage unavailable; the panel just shows again next navigation */
  }

  // Anyone who reaches for the page has said they are ready to see it.
  const onIntent = () => dismiss();
  const options = { once: true, passive: true };
  window.addEventListener('pointerdown', onIntent, options);
  window.addEventListener('wheel', onIntent, options);
  window.addEventListener('touchstart', onIntent, options);
  window.addEventListener('keydown', onIntent, { once: true });

  // Belt and braces: if the animation never runs — a browser that has them
  // disabled, a stylesheet that failed — remove the panel anyway shortly after
  // it should have finished, so it can never become a permanent cover.
  const seconds = Number.parseFloat(panel.dataset.introDuration || '5');
  const total = (Number.isFinite(seconds) ? seconds : 5) * 1000 + 800;
  window.setTimeout(dismiss, total);
})();
